import {
  CloseButton,
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';

import DButtonIcon from '../DButtonIcon';
import ChevronLeftIcon from '../Icons/ChevronLeftIcon';
import CloseIcon from '../Icons/CloseIcon';

const DModal = ({
  children,
  title,
  subtitle,
  isOpen,
  onClose,
  footer,
  backBtn,
  onBack,
  hideCloseButton = false,
  closeBackdrop = true,
}) => {
  return (
    <>
      <Dialog open={isOpen} onClose={() => closeBackdrop && onClose()} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 duration-150 bg-white/90 data-[closed]:opacity-0 data-[leave]:delay-100"
        />

        <div className="fixed inset-0 flex w-screen items-center justify-center">
          <DialogPanel
            transition
            className="transition-all duration-200 w-11/12 md:w-full md:max-w-[500px] max-h-[80vh] bg-white p-size6 rounded-size1 flex flex-col gap-size5 border border-grey-5 transition data-[enter]:delay-100 duration-150 data-[closed]:-translate-y-20 data-[closed]:opacity-0"
          >
            <header
              className={`flex ${
                title ? ' justify-between' : 'justify-end'
              }  items-center`}
            >
              {backBtn && (
                <button onClick={() => onBack()}>
                  <ChevronLeftIcon />
                </button>
              )}
              <div className="flex flex-col gap-size1 max-w-[100%]">
                {title && (
                  <DialogTitle className="text-xl">{title}</DialogTitle>
                )}
                {subtitle && (
                  <DialogTitle className="text-sm text-grey-50 w-full">
                    {subtitle}
                  </DialogTitle>
                )}
              </div>
              {!hideCloseButton && (
                <CloseButton>
                  <CloseIcon width={24} height={24} />
                </CloseButton>
              )}
            </header>
            
            {title && <div className="w-full h-px bg-grey-5"></div>}
            <main className="text-lg grow overflow-y-auto overflow-x-hidden">{children}</main>
            {footer && (
              <footer className="flex items-center gap-size1 w-full">
                {footer}
              </footer>
            )}
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
};
export default DModal;
